import { useState } from 'react';
export function useDebounce(func, delay = 1000) {
    const [timer, setTimer] = useState();
    const debouncedFunction = ((...args) => {
        if (timer) {
            clearTimeout(timer);
        }
        const newTimer = setTimeout(() => {
            func(...args);
        }, delay);
        setTimer(newTimer);
    });
    return debouncedFunction;
}
